import { RadioGroup } from "@outschool/backpack";
import {
  OSSubscriptions,
  Search as SearchFilters,
} from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { Filter, FilterList } from "@outschool/ui-components-website";
import React from "react";

type CreditsPerMeetingFilterProps = {
  handleChangesExternally?: boolean;
  onChange: (value: $TSFixMe) => void;
  value: SearchFiltersType;
};

export default function CreditsPerMeetingFilter({
  handleChangesExternally,
  onChange,
  value,
}: CreditsPerMeetingFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\CreditsPerMeetingFilter",
  );
  const [pricePerMeeting, setPricePerMeeting] = React.useState(value || {});
  const handleFilterChange = (_e: any, value: string) => {
    const parsedValue = JSON.parse(value);
    setPricePerMeeting(parsedValue);
    if (handleChangesExternally) {
      onChange(parsedValue);
    }
  };

  const creditPriceOptions = SearchFilters.CREDIT_PRICE_PER_MEETING_OPTIONS.map(
    option => {
      const creditMax = option.priceCreditsPerMeetingMax;
      const creditMin = option.priceCreditsPerMeetingMin;
      return !creditMax && !creditMin
        ? {
            label: t("Any"),
            value: JSON.stringify(option),
          }
        : creditMax
        ? {
            label: t("{{creditMax}} credits or less", { creditMax }),
            value: JSON.stringify({
              pricePerMeetingMax:
                OSSubscriptions.creditsToPriceCents(creditMax) / 100,
            }),
          }
        : {
            label: t("Over {{creditMin}} credits", { creditMin }),
            value: JSON.stringify({
              pricePerMeetingMin:
                OSSubscriptions.creditsToPriceCents(creditMin!) / 100,
            }),
          };
    },
  );

  return (
    <FilterList>
      <Filter title={t("Cost per class")}>
        <RadioGroup
          name="price"
          value={JSON.stringify(pricePerMeeting)}
          options={creditPriceOptions}
          onChange={handleFilterChange}
        />
      </Filter>
    </FilterList>
  );
}
